// Cash denominations, keyed by cents as a string ("2000" = $20) — the same
// keys the cash-drawer-count function and verify_drawer_deposit store.

export const DENOMS = [
  { label: "$100", cents: 10000 },
  { label: "$50", cents: 5000 },
  { label: "$20", cents: 2000 },
  { label: "$10", cents: 1000 },
  { label: "$5", cents: 500 },
  { label: "$1", cents: 100 },
  { label: "25¢", cents: 25 },
  { label: "10¢", cents: 10 },
  { label: "5¢", cents: 5 },
  { label: "1¢", cents: 1 },
];

export type DenomCounts = Record<string, number>;

export function denomTotalCents(counts: DenomCounts): number {
  let sum = 0;
  for (const [centsStr, qty] of Object.entries(counts)) {
    sum += parseInt(centsStr, 10) * (qty || 0);
  }
  return sum;
}

/** "2×$20, 9×$1, 5×1¢": largest first, counted denominations only. Used where only text
 *  can be stored (verify_bank_run has no breakdown column, so it goes in the run note). */
export function denomSummary(counts: DenomCounts): string {
  return DENOMS.filter((d) => (counts[String(d.cents)] || 0) > 0)
    .map((d) => `${counts[String(d.cents)]}×${d.label}`)
    .join(", ");
}

export function anyCounted(counts: DenomCounts): boolean {
  return Object.values(counts).some((v) => (v || 0) > 0);
}

/** Only the denominations actually counted, so a stored breakdown has no zero rows. */
export function nonZeroDenoms(counts: DenomCounts): DenomCounts {
  const out: DenomCounts = {};
  for (const [k, v] of Object.entries(counts)) if (v > 0) out[k] = v;
  return out;
}
